<template>
    <v-row class="mt-0">
        <slot />
    </v-row>
</template>

<script>
export default {
    name: 'TicketWorkspace',
};
</script>
